import { Form, Formik } from "formik";
import Dialog from "components/Overlays/ResponsiveDialog";
import { useRef, useState } from "react";
import { FiEdit2 } from "react-icons/fi";
import * as Yup from "yup";
import useUpdateShippingAddress from "api/AddressResource/useUpdateShippingAddress";
import AccountField from "../AccountField";

const EditShippingAddress = ({ addressId, nickname, recipientName, recipientPhone }) => {
	const [visible, setVisible] = useState(false);
	const trigger = useRef(null);
	const { mutateAsync, isLoading } = useUpdateShippingAddress(addressId);
	const close = () => {
		if (!isLoading) {
			setVisible(false);
			trigger.current?.focus();
		}
	};
	return (
		<>
			<button
				ref={trigger}
				type="button"
				className="account-icon-button"
				aria-label={`Edit ${nickname || "delivery address"}`}
				onClick={() => setVisible(true)}
			>
				<FiEdit2 aria-hidden="true" />
			</button>
			<Dialog
				header="Edit delivery details"
				visible={visible}
				onHide={close}
				className="account-dialog"
				maskClassName="account-dialog-mask"
				draggable={false}
				resizable={false}
				blockScroll
				closable={!isLoading}
				closeOnEscape={!isLoading}
				ariaCloseIconLabel="Close address editor"
			>
				<Formik
					initialValues={{
						nickname: nickname || "",
						recipient_name: recipientName || "",
						recipient_phone: recipientPhone || "",
					}}
					validationSchema={Yup.object().shape({
						nickname: Yup.string().required("Enter an address label"),
						recipient_name: Yup.string().required("Enter the recipient’s name"),
						recipient_phone: Yup.string().required("Enter the recipient’s phone number"),
					})}
					onSubmit={async (values) => {
						try {
							await mutateAsync(values);
							setVisible(false);
							trigger.current?.focus();
						} catch (_) {
							/* The mutation displays errors. */
						}
					}}
				>
					<Form className="account-security-fields">
						<AccountField
							name="nickname"
							label="Address label"
							placeholder="Home, work, or somewhere else"
							required
						/>
						<AccountField
							name="recipient_name"
							label="Recipient name"
							autoComplete="name"
							required
						/>
						<AccountField
							name="recipient_phone"
							type="tel"
							label="Recipient phone number"
							autoComplete="tel"
							required
						/>
						<div className="account-dialog-footer">
							<button
								type="button"
								className="account-button secondary"
								disabled={isLoading}
								onClick={close}
							>
								Cancel
							</button>
							<button type="submit" className="account-button" disabled={isLoading}>
								{isLoading ? "Saving…" : "Save details"}
							</button>
						</div>
					</Form>
				</Formik>
			</Dialog>
		</>
	);
};
export default EditShippingAddress;
